import { authApi } from "@b2bportal/auth-api";
import { axiosInstance } from "@hopper-b2b/api";

export const removeSession = async () => {
  try {
    const res = await authApi(axiosInstance).apiV0AuthSessionRemovePut();
    return res.data;
  } catch (error) {
    console.error("Remove session error:", error);
    throw Error("Remove session error");
  }
};
